import type { SVGProps } from 'react';

export const SvgImgIllustGas = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 204 170" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M102.001 157.728L2 99.9924L101.999 42.2584L202 99.9938L102.001 157.728Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M2 110.078V99.9924L102.001 157.728V167.814L2 110.078Z"
      fill="url(#paint0_linear_4444_1999)"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M201.999 99.9939V110.078L102 167.814V157.728L201.999 99.9939Z"
      fill="url(#paint1_linear_4444_1999)"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M80.2285 45.4281C80.2285 51.0848 84.4069 55.6719 89.5607 55.6719C94.7145 55.6719 98.8929 51.0862 98.8929 45.4281C98.8929 39.7699 94.7145 2.22217 89.5607 2.22217C84.4069 2.22217 80.2285 39.7699 80.2285 45.4281Z"
      fill="#F5CE2F"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeMiterlimit="10"></path>
    <path
      d="M85.168 48.7688C85.168 51.4298 87.1333 53.5878 89.558 53.5878C91.9827 53.5878 93.948 51.4298 93.948 48.7688C93.948 46.1079 91.9827 28.442 89.558 28.442C87.1333 28.442 85.168 46.1064 85.168 48.7688Z"
      fill="#ED9027"></path>
    <path
      d="M106.058 45.4281C106.058 51.0848 110.236 55.6719 115.39 55.6719C120.544 55.6719 124.722 51.0862 124.722 45.4281C124.722 39.7699 120.544 2.22217 115.39 2.22217C110.236 2.22217 106.058 39.7699 106.058 45.4281Z"
      fill="#F5CE2F"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeMiterlimit="10"></path>
    <path
      d="M110.997 48.7688C110.997 51.4298 112.962 53.5878 115.387 53.5878C117.812 53.5878 119.777 51.4298 119.777 48.7688C119.777 46.1079 117.812 28.442 115.387 28.442C112.962 28.442 110.997 46.1064 110.997 48.7688Z"
      fill="#ED9027"></path>
    <path
      d="M101.994 49.918C92.4037 49.918 82.8164 52.0296 75.5002 56.253C68.184 60.4778 64.5259 66.0127 64.5259 71.5492C64.5259 77.0856 68.184 82.622 75.5002 86.8468C82.8178 91.0702 92.4066 93.1833 101.994 93.1833C111.581 93.1833 121.173 91.0702 128.489 86.8468C135.805 82.622 139.463 77.0871 139.463 71.5506C139.463 66.0142 135.805 60.4778 128.489 56.253C121.173 52.0282 111.583 49.918 101.994 49.918Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M101.995 41.4583C91.8351 41.4583 81.6768 43.696 73.9258 48.1715C66.1748 52.6471 62.2993 58.511 62.2993 64.3765C62.2993 70.2419 66.1748 76.1073 73.9258 80.5828C81.6768 85.0584 91.8366 87.2961 101.995 87.2961C112.153 87.2961 122.313 85.0584 130.065 80.5828C137.816 76.1088 141.691 70.2433 141.691 64.3779C141.691 58.5125 137.816 52.6471 130.065 48.1715C122.313 43.696 112.155 41.4583 101.995 41.4583Z"
      fill="#B5B4B5"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M62.5038 42.2004L59.8906 46.6412L63.111 44.7556L64.1415 43.0266L62.5038 42.2004Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M87.8579 50.8834L85.6099 52.1806L56.6567 36.0974L59.8771 34.2133L87.8579 50.8834Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M56.8988 35.9569L56.6567 36.0975L85.6099 52.1807L85.8534 52.0401L56.8988 35.9569Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M87.8587 50.8834L85.6108 52.1806V53.8545L87.8587 52.5588V50.8834Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M56.6576 36.0974L54.6821 43.6339L59.891 46.6413L62.5041 42.2005L85.6108 53.8546V52.1806L56.6576 36.0974Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M144.486 86.7802L146.46 96.5979L141.252 93.592L138.639 86.1324L116.64 71.7463V70.0709L144.486 86.7802Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M147.678 84.9366L144.486 86.7802L116.64 70.0709L118.86 68.8129L147.678 84.9366Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M116.861 69.9463L116.64 70.0709L144.486 86.7802L144.706 86.6541L116.861 69.9463Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M147.68 84.9368L144.487 86.7803L146.461 96.598L149.654 94.7516L147.68 84.9368Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M147.679 36.0975L149.655 43.634L144.446 46.6414L141.833 42.2007L118.728 53.8547V52.1807L147.679 36.0975Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M141.831 42.2004L144.444 46.6412L141.226 44.7556L140.194 43.0266L141.831 42.2004Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M116.479 50.8834L118.727 52.1806L147.679 36.0974L144.458 34.2133L116.479 50.8834Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M147.439 35.9569L147.68 36.0975L118.728 52.1807L118.484 52.0401L147.439 35.9569Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M116.479 50.8834L118.727 52.1806V53.8545L116.479 52.5588V50.8834Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M59.8505 86.7802L57.8765 96.5979L63.0839 93.592L65.697 86.1324L87.6964 71.7463V70.0709L59.8505 86.7802Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M56.6567 84.9366L59.8496 86.7802L87.6955 70.0709L85.4737 68.8129L56.6567 84.9366Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M87.4715 69.9462L87.6947 70.0708L59.8487 86.7801L59.6299 86.654L87.4715 69.9462Z"
      fill="#FBDED7"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M56.6576 84.9366L59.8504 86.7802L57.8764 96.5979L54.6821 94.7515L56.6576 84.9366Z"
      fill="#FF0019"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeLinecap="round"
      strokeLinejoin="round"></path>
    <path
      d="M138.481 82.0918C138.481 87.7485 134.302 92.3356 129.149 92.3356C123.995 92.3356 119.816 87.7499 119.816 82.0918C119.816 76.4336 123.995 38.8859 129.149 38.8859C134.302 38.8859 138.481 76.4336 138.481 82.0918Z"
      fill="#F5CE2F"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeMiterlimit="10"></path>
    <path
      d="M133.54 85.4917C133.54 88.1527 131.575 90.3107 129.15 90.3107C126.726 90.3107 124.76 88.1527 124.76 85.4917C124.76 82.8308 126.726 65.1649 129.15 65.1649C131.575 65.1649 133.54 82.8293 133.54 85.4917Z"
      fill="#ED9027"></path>
    <path
      d="M111.858 88.9455C111.858 94.6022 107.679 99.1894 102.526 99.1894C97.3718 99.1894 93.1934 94.6037 93.1934 88.9455C93.1934 83.2873 97.3718 45.7396 102.526 45.7396C107.679 45.7396 111.858 83.2873 111.858 88.9455Z"
      fill="#F5CE2F"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeMiterlimit="10"></path>
    <path
      d="M106.917 92.3455C106.917 95.0065 104.951 97.1645 102.527 97.1645C100.102 97.1645 98.1367 95.0065 98.1367 92.3455C98.1367 89.6845 100.102 72.0187 102.527 72.0187C104.951 72.0187 106.917 89.6831 106.917 92.3455Z"
      fill="#ED9027"></path>
    <path
      d="M67.1962 58.8488C67.1962 64.5056 63.0178 69.0927 57.864 69.0927C52.7102 69.0927 48.5317 64.507 48.5317 58.8488C48.5317 53.1907 52.7102 15.6429 57.864 15.6429C63.0178 15.6429 67.1962 53.1907 67.1962 58.8488Z"
      fill="#F5CE2F"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeMiterlimit="10"></path>
    <path
      d="M62.2556 62.2489C62.2556 64.9099 60.2903 67.0679 57.8656 67.0679C55.4409 67.0679 53.4756 64.9099 53.4756 62.2489C53.4756 59.588 55.4409 41.9221 57.8656 41.9221C60.2903 41.9221 62.2556 59.5865 62.2556 62.2489Z"
      fill="#ED9027"></path>
    <path
      d="M155.464 58.8487C155.464 64.5054 151.286 69.0926 146.132 69.0926C140.978 69.0926 136.8 64.5069 136.8 58.8487C136.8 53.1905 140.978 15.6428 146.132 15.6428C151.286 15.6428 155.464 53.1905 155.464 58.8487Z"
      fill="#F5CE2F"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeMiterlimit="10"></path>
    <path
      d="M150.524 62.2489C150.524 64.9099 148.558 67.0679 146.134 67.0679C143.709 67.0679 141.744 64.9099 141.744 62.2489C141.744 59.588 143.709 41.9221 146.134 41.9221C148.558 41.9221 150.524 59.5865 150.524 62.2489Z"
      fill="#ED9027"></path>
    <path
      d="M84.0365 82.0915C84.0365 87.7482 79.8581 92.3354 74.7043 92.3354C69.5505 92.3354 65.3721 87.7497 65.3721 82.0915C65.3721 76.4333 69.5505 38.8856 74.7043 38.8856C79.8581 38.8856 84.0365 76.4333 84.0365 82.0915Z"
      fill="#F5CE2F"
      stroke="#FF0019"
      strokeWidth="3.11111"
      strokeMiterlimit="10"></path>
    <path
      d="M79.0955 85.4917C79.0955 88.1527 77.1302 90.3107 74.7054 90.3107C72.2807 90.3107 70.3154 88.1527 70.3154 85.4917C70.3154 82.8308 72.2807 65.1649 74.7054 65.1649C77.1302 65.1649 79.0955 82.8293 79.0955 85.4917Z"
      fill="#ED9027"></path>
    <defs>
      <linearGradient
        id="paint0_linear_4444_1999"
        x1="54.0308"
        y1="130.443"
        x2="48.1524"
        y2="140.461"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A"></stop>
        <stop offset="0.29" stopColor="#F5B3A4"></stop>
        <stop offset="0.75" stopColor="#F9D2C8"></stop>
        <stop offset="1" stopColor="#FBDED7"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_4444_1999"
        x1="152.289"
        y1="175.037"
        x2="151.786"
        y2="103.468"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A"></stop>
        <stop offset="0.51" stopColor="#ED8B7D"></stop>
        <stop offset="1" stopColor="#EB7D74"></stop>
      </linearGradient>
    </defs>
  </svg>
);
